/**
 * @orchard9ai/testing-utils
 *
 * Testing utilities for Orchard9 platform
 */

export const VERSION = '0.1.0';

// Render utilities
export { render, renderWithProviders, renderHook, createWrapper } from './render/render';
export type { ProvidersConfig } from './render/types';

// Test data builders
export {
  userBuilder,
  authenticatedUserBuilder,
  createUserInputBuilder,
  createUsers,
} from './builders/user';

export {
  apiResponseBuilder,
  apiErrorBuilder,
  apiErrorResponseBuilder,
  paginatedResponseBuilder,
  batchResponseBuilder,
  healthCheckResponseBuilder,
} from './builders/api';

// Mock utilities
export {
  MockFetch,
  createMockFetch,
  installMockFetch,
  restoreFetch,
  type MockFetchOptions,
} from './mocks/fetch';

// Async utilities
export {
  waitFor,
  waitForNextTick,
  flushMicrotasks,
  retry,
  createDeferred,
  waitForAsync,
  timeout,
  withTimeout,
  delay,
  createAbortable,
  poll,
  flushTimers,
  advanceTimersByTime,
} from './utils/async';

// Accessibility utilities
export {
  axeConfig,
  checkA11y,
  expectNoA11yViolations,
  getAccessibilityTree,
  checkKeyboardNavigation,
  checkAriaLabels,
  assertFocusManagement,
  assertAriaCompliance,
} from './utils/accessibility';

// Re-export testing library utilities
export {
  screen,
  fireEvent,
  waitFor as waitForElement,
  within,
  cleanup,
  act,
} from '@testing-library/react';

export { default as userEvent } from '@testing-library/user-event';

// Re-export jest-dom matchers
import '@testing-library/jest-dom';
